<template>
	<Layout>
		<div class="directory-container">
			<div class="container">
				<div class="navbar-group justify-space-between flex-wrap gap-2">
					<div><TrialModal /></div>

					<div style="flex-grow: 1; max-width: 100%; position: relative">
						<v-text-field
							style="width: 350px; max-width: 100%; margin-left: auto"
							class="custom-input"
							label="Search Trials"
							variant="outlined"
							bg-color="white"
							color="gray300"
							density="comfortable"
							v-model="state.search"
							append-inner-icon="mdi-magnify"
							clearable
							data-cy="trial-search-input"
						>
							<template #append-inner>
								<div class="d-flex align-center">
									<v-icon>mdi-magnify</v-icon>
									<v-menu
										location="bottom right"
										@update:model-value="state.showSelectionMenu = $event"
									>
										<template #activator="{ props }">
											<v-icon v-bind="props" class="ml-2">mdi-menu-down</v-icon>
										</template>
										<v-list>
											<v-list-item
												active-color="primary"
												:active="state.status == 'requested'"
												value="requested"
												@click="state.status = 'requested'"
												>Requested Trials</v-list-item
											>
											<v-list-item
												active-color="primary"
												:active="state.status == 'pending'"
												value="pending"
												@click="state.status = 'pending'"
												>Pending Trials</v-list-item
											>
											<v-list-item
												active-color="primary"
												:active="state.status == 'fulfilled'"
												value="fulfilled"
												@click="state.status = 'fulfilled'"
												>Fulfilled Trials</v-list-item
											>
											<v-list-item
												active-color="primary"
												:active="state.status == 'expired'"
												value="expired"
												@click="state.status = 'expired'"
												>Expired Trials</v-list-item
											>
											<v-list-item
												active-color="primary"
												:active="state.status == 'cancelled'"
												value="cancelled"
												@click="state.status = 'cancelled'"
												>Cancelled Trials</v-list-item
											>
											<v-list-item
												active-color="primary"
												:active="state.status == 'rejected'"
												value="rejected"
												@click="state.status = 'rejected'"
												>Rejected Trials</v-list-item
											>
											<v-list-item
												active-color="primary"
												:active="state.status == 'all'"
												value="all"
												@click="state.status = 'all'"
												>All Trials</v-list-item
											>
											<v-divider class="my-1" />
											<v-list-item
												active-color="primary"
												:active="state.status == 'demo'"
												value="demo"
												@click="state.status = 'demo'"
											>
												<template #prepend>
													<v-icon size="small" class="mr-2">mdi-calendar-check</v-icon>
												</template>
												Demo Requests
											</v-list-item>
										</v-list>
									</v-menu>
								</div>
							</template>
						</v-text-field>
					</div>
				</div>
				<TrialsDirectory
					:status="state.status"
					:search="state.search || ''"
					@update:search="state.search = $event"
				/>
			</div>
		</div>
	</Layout>
</template>

<script setup lang="ts">
import Layout from "@/views/support/Layout.vue";
import TrialsDirectory from "@/components/support/TrialsDirectory.vue";
import { reactive } from "vue";
import TrialModal from "@/components/support/TrialModal.vue";

const state = reactive({
	search: "",
	showSelectionMenu: false,
	status: "requested", // Default to showing pending trials since those need attention
});
</script>

<style scoped lang="scss">
.directory-container {
	padding: 20px 30px 0;
}
</style>
